module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1dfc1f73867cf8259be121b6b227a2c7.png";